import type { TFunction } from "i18next";

import {
  involvementKindsHeldByUser,
  LISTING_INVOLVEMENT_RANK,
  type PersonInvolvementKind,
  type ViewRouteUnbranded,
} from "@thalamos/haven-common";

/** A row's own involvements in the order the listing sorts them by. */
export const inListingOrder = (
  types: readonly PersonInvolvementKind[],
): PersonInvolvementKind[] =>
  types.toSorted(
    (a, b) => LISTING_INVOLVEMENT_RANK[a] - LISTING_INVOLVEMENT_RANK[b],
  );

/**
 * What the "Your involvement" cell says: every part the user holds, in the
 * order the column sorts by, or that they see the child through their
 * organisation.
 */
export const involvementLabelOf = (
  routes: readonly ViewRouteUnbranded[],
  organisationName: string | undefined,
  t: TFunction,
): string => {
  const own = inListingOrder(involvementKindsHeldByUser(routes));

  return own.length === 0
    ? t("personListing.viewerThrough", { organisation: organisationName })
    : own.map((kind) => t(`access.kind.${kind}`)).join(", ");
};
